
import { defineComponent, ref, reactive, toRefs, onMounted, watchEffect, computed, watch, nextTick, WritableComputedRef } from 'vue'
import { SearchOutlined, CloseCircleFilled, DeleteOutlined } from '@ant-design/icons-vue'
import Askcollapse from '@/components/asktheSecretary/askcollapse.vue'
import Nodata from '@/components/page/nodata.vue'
import jfshool from '@/api/jfschool'
import store from '@/store'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import { gotoClientLogin } from '@/utils/stock'
const application = ['uranus', 'superstars'] // 擒龙pc,旗舰pc（暂时不用
interface pageDataType {
  value: string
  showInput: boolean
  placeholder: string
  groupsList: any
  coursesList: any
  options: any
  groups: any
  courses: any
  activeType: string
  classes: any
  getPopupContainer: any
  historyData: any
  selectDisabled: boolean
  KeyWords: string
  activeLi?: WritableComputedRef<string>
  activeindex: number
  showDropdown: boolean
  selectOption: any
  errorRequest: boolean
  [propName: string]: any
}
interface EventType extends Event {
  code?: string
}
export default defineComponent({
  name: 'SearchCourse',
  components: {
    SearchOutlined,
    CloseCircleFilled,
    Askcollapse,
    DeleteOutlined,
    Nodata
  },
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    }
  },
  setup(props: any, content: any) {
    const route = useRoute()
    const pageData: pageDataType = reactive({
      value: '',
      showInput: true,
      placeholder: '搜索课程/专题',
      groupsList: [],
      coursesList: [],
      options: [], // 全部
      groups: [], // 专题
      courses: [], // 课程
      activeType: 'options', // groups courses
      classes: [
        {
          name: '全部',
          id: 'options'
        },
        {
          name: '专题',
          id: 'groups'
        },
        {
          name: '课程',
          id: 'courses'
        }
      ],
      getPopupContainer: (e: HTMLElement) => e.parentNode,
      historyData: [], // .reverse()
      selectDisabled: false,
      KeyWords: '',
      // activeLi: '',
      activeindex: 0,
      showDropdown: false,
      selectOption: [],
      errorRequest: false
    })
    const askingselect = ref()
    const scrollWrapper = ref()
    pageData.activeLi = computed(() => {
      const res = pageData.selectOption.length ? pageData.selectOption[pageData.activeindex].Id : ''
      return res.toString()
    })
    pageData.selectOption = computed(() => {
      const [...history] = pageData.historyData
      const data = !pageData.value.length && history.length ? history.reverse() : pageData.options
      return (data || []) as any
    })
    async function getlist() {
      const data: any = {}
      data.data = {}
      data.headers = {
        'Content-Type': 'application/json',
        appcode: store.state.pcqueryInfo.appcode
      }
      jfshool.getSearchCourse(data).then((res: any) => {
        if (res.code !== 1) {
          pageData.errorRequest = true
        } else {
          const index = route.query.softNameAbbr === 'jfzt' ? 1 : 0
          const result = res.data[application[index]]
          // 课程 courseName  courseNo  专题 groupName groupCode
          pageData.groupsList = result.learnGroupTypeDTOS.map((item: any) => Object.assign(item, { Id: item.groupCode }))
          pageData.coursesList = result.courseDTOS.map((item: any) => Object.assign(item, { Id: item.courseNo }))
        }
      })
    }
    function handleChange(e: EventType, value: any) {
      if (value.type && value.type === 'notCourseGroup') {
        // 历史记录，非课程且非专题
        pageData.value = value.Id
        searchValue()
        hanldeHistory(value.Id)
      } else {
        hanldeHistory(value.Id)
        jumpToDetail(value)
        pageData.activeType = pageData.classes[0].id
        // pageData.activeindex = 0
        pageData.value = ''
        searchValue()
        blurSelect(1)
        askingselect.value.blur()
      }
      e.stopPropagation()
      return false
    }
    function filterGroups(val: string) {
      if (!val) return
      return pageData.groupsList.filter((item: any) => item.groupName.indexOf(val) > -1)
    }
    function filterCourses(val: string) {
      if (!val) return
      return pageData.coursesList.filter((item: any) => item.courseName.indexOf(val) > -1)
    }
    function searchValue() {
      pageData.activeindex = 0
      nextTick(() => {
        if (scrollWrapper.value) {
          scrollWrapper.value.scrollTop = 0
        }
      })
      if (!pageData.value || pageData.errorRequest) {
        pageData.options = []
        return
      }
      pageData.groups = filterGroups(pageData.value) || []
      pageData.courses = filterCourses(pageData.value) || []
      pageData.options = pageData.groups.concat(pageData.courses)
    }

    async function focusSelect() {
      if (!pageData.showDropdown) {
        await getlist()
        pageData.showDropdown = true
        // pageData.activeindex = 0
        window.addEventListener('keydown', handlekeyFn, !0)
        const history = JSON.parse(sessionStorage.getItem('jfSchoolHistory') || '[]') || [] // .reverse()
        pageData.historyData = history.splice(history.length > 10 ? history.length - 10 : 0, 10)
      }
    }
    // 失去焦点时关闭弹窗
    let timer: any = null
    function blurSelect(t?: number) {
      timer = setTimeout(() => {
        pageData.showDropdown = false
      }, t || 200)
    }
    function enterSelect() {
      if (!pageData.activeLi && !pageData.value.length) return
      if (pageData.errorRequest) {
        reRequest()
        return
      }
      const value = pageData.value.trim()
      if ((pageData.activeLi || '').toString() !== '') {
        // 跳转 currentItem  or 搜索关键词
        const currentItem = pageData.selectOption.find((item: any) => item.Id === pageData.activeLi)
        hanldeHistory(pageData.activeLi)
        if (currentItem.type && currentItem.type === 'notCourseGroup') {
          pageData.value = currentItem.Id
          searchValue()
        } else {
          jumpToDetail(currentItem)
          pageData.activeType = pageData.classes[0].id
          // pageData.activeindex = 0
          pageData.value = ''
          searchValue()
          blurSelect(1)
          askingselect.value.blur()
        }
      } else if (value.length) {
        // hanldeHistory(value)
      }
    }
    function jumpToDetail(currentItem: any) {
      if (currentItem.courseNo) {
        const query = JSON.parse(JSON.stringify(route.query))
        delete query.groupCode
        if (!route.query.token) {
          gotoClientLogin()
          return
        }
        router.push({
          name: 'coursedetail',
          query: {
            ...query,
            courseNo: currentItem.courseNo,
            lessonNo: null
          },
          params: {
            nogroupName: 'true'
          }
        })
      } else if (currentItem.groupCode) {
        const query = JSON.parse(JSON.stringify(route.query))
        delete query.courseNo
        router.push({
          name: 'specialcourse',
          query: {
            ...query,
            groupCode: currentItem.groupCode,
            groupName: currentItem.groupName
          }
        })
      }
    }
    function hanldeHistory(id: any) {
      const history = pageData.historyData.filter((item: any) => item.Id !== id)
      const currentItem = pageData.selectOption.find((item: any) => item.Id === id)
      if (currentItem) {
        history.push(currentItem)
      } else {
        history.push({
          groupName: id,
          Id: id,
          type: 'notCourseGroup'
        })
      }
      if (history.length > 10) {
        history.splice(0, 1)
      }
      // const history = JSON.parse(sessionStorage.getItem('jfSchoolHistory') || '[]') || []
      sessionStorage.setItem('jfSchoolHistory', JSON.stringify(history))
      pageData.historyData = history
    }
    function clearHistory() {
      pageData.historyData = []
      sessionStorage.removeItem('jfSchoolHistory')
    }
    function cleartagsCall() {
      // pageData.activeindex = 0
      pageData.value = ''
      searchValue()
      preventBlur()
    }
    function cancelArrowUp(e: EventType) {
      if (e.code === 'ArrowUp') {
        e.preventDefault()
        return false
      }
    }
    function handlekeyFn(e: EventType) {
      if (e.code !== 'ArrowDown' && e.code !== 'ArrowUp' && e.code !== 'Enter') return
      // 向下箭头
      if (e.code === 'ArrowDown') {
        pageData.activeindex++
        if (pageData.activeindex >= pageData.selectOption.length) {
          pageData.activeindex = pageData.selectOption.length - 1
        }
      } else if (e.code === 'ArrowUp') {
        pageData.activeindex--
        if (pageData.activeindex < 0) {
          pageData.activeindex = 0
        }
      } else if (e.code === 'Enter') {
        enterSelect()
      }
      nextTick(() => {
        if (pageData.activeindex < 7) {
          if (scrollWrapper.value) {
            scrollWrapper.value.scrollTop = 0
          }
        } else {
          if (scrollWrapper.value) {
            scrollWrapper.value.scrollTop = pageData.activeindex * 24 - 140
          }
        }
      })
    }
    function inputKeyup(e: EventType) {
      if (e.code === 'Enter') {
        enterSelect()
      }
    }
    function changeType(id: string) {
      pageData.activeindex = 0
      nextTick(() => {
        if (scrollWrapper.value) {
          scrollWrapper.value.scrollTop = 0
        }
      })
      pageData.activeType = id
      if (id === 'options') {
        pageData.options = pageData.groups.concat(pageData.courses)
      } else {
        pageData.options = pageData[id]
      }
    }
    function reRequest() {
      getlist()
    }
    function preventBlur() {
      if (timer) {
        clearTimeout(timer)
      }
    }
    function hightKeywords(str: string, key: string) {
      const re = new RegExp(key, 'i')
      let newString = ''
      let newname = str
      if (re.test(str)) {
        const exec = re.exec(str) || []
        newString = `<font style="color: #ff5c5c">${exec[0]}</font>`
        newname = str.replace(exec[0], newString)
      }
      return newname
    }

    return {
      ...toRefs(pageData),
      handleChange,
      searchValue,
      focusSelect,
      clearHistory,
      blurSelect,
      cleartagsCall,
      askingselect,
      enterSelect,
      handlekeyFn,
      inputKeyup,
      changeType,
      scrollWrapper,
      reRequest,
      preventBlur,
      cancelArrowUp,
      hightKeywords
    }
  }
})
